import { render, staticRenderFns } from "./MultiSelectVeranstaltung.vue?vue&type=template&id=4202b08c&"
import script from "./MultiSelectVeranstaltung.vue?vue&type=script&lang=js&"
export * from "./MultiSelectVeranstaltung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports